import { ModelBase, observable } from "@shoothill/core";

export class TestAndInspectionsListModel extends ModelBase<TestAndInspectionsListModel> {
    public id: string = "";
    @observable
    public inspectionTypeDisplayName: string = "";
    @observable
    public serialRegistrationNo: string = "";
    @observable
    public firstName: string = "";
    @observable
    public lastName: string = "";
    @observable
    public createdDate: string = "";
    @observable
    public lastUpdatedByUserName: string = "";

    constructor() {
        super();
    }

    fromDto(model: TestAndInspectionsListDTO): void {
        this.id = model.id;
        this.inspectionTypeDisplayName = model.inspectionTypeDisplayName;
        this.serialRegistrationNo = model.serialRegistrationNo;
        this.firstName = model.firstName;
        this.lastName = model.lastName;
        this.createdDate = model.createdDate;
    }
    toDto(model: TestAndInspectionsListModel): void {
        throw new Error("Method not implemented.");
    }
}

export interface TestAndInspectionsListDTO {
    id: string;
    inspectionTypeDisplayName: string;
    serialRegistrationNo: string;
    firstName: string;
    lastName: string;
    createdDate: string;
}

export interface TestAndInspectionsTypeDTO {
    id: string;
    displayName: string;
    type: number;
    ordinal: number;
    isDeleted: boolean;
}

export interface TestAndInspectionsListAndRelatedDTO {
    inspections: TestAndInspectionsListDTO[];
    inspectionTypes: TestAndInspectionsTypeDTO[];
}

export interface FormRequestDTO {
    date: string | null;
    projectId: string | null;
}
